import { styled } from "@mui/styles";
import React from "react";

type TabPanelProps = {
  children?: React.ReactNode;
  index: number;
  value: number;
};

const AllHeightDiv = styled("div")({
  // Los 48px son del height de las Tabs
  height: "calc(100% - 48px)",
  marginTop: 2,
});

const TabPanel = (props: TabPanelProps) => {
  const { children, value, index, ...other } = props;

  return (
    <AllHeightDiv
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && children}
    </AllHeightDiv>
  );
};

export default TabPanel;
